module.exports = __webpack_public_path__ + "static/fonts/iconfont.8b62fcb3.ttf";